import { render, staticRenderFns } from "./selectProducts.vue?vue&type=template&id=1a6b7fa0&scoped=true"
import script from "./selectProducts.vue?vue&type=script&lang=js"
export * from "./selectProducts.vue?vue&type=script&lang=js"
import style0 from "./selectProducts.vue?vue&type=style&index=0&id=1a6b7fa0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6b7fa0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a6b7fa0')) {
      api.createRecord('1a6b7fa0', component.options)
    } else {
      api.reload('1a6b7fa0', component.options)
    }
    module.hot.accept("./selectProducts.vue?vue&type=template&id=1a6b7fa0&scoped=true", function () {
      api.rerender('1a6b7fa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplier/coupons/selectProducts.vue"
export default component.exports